var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sugestion" },
    [
      _c("h3", [_vm._v("Com dúvida sobre quem escolher?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    A profissional "),
        _c("span", [_vm._v(_vm._s(_vm._f("firstName")(_vm.professional)))]),
        _vm._v(
          " é uma ótima escolha. Ela vem sendo muito procurada e tem recebido uma alta quantidade de agendamentos nas últimas semanas.\n  "
        )
      ]),
      _vm._v(" "),
      _vm._t("card")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c3b44fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c3b44fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Sugestion.vue
// module id = null
// module chunks = 